/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

// user menu
export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'custom:dashboard',
        link: '/dashboard'
    },
    {
        id: 'genealogyTree',
        title: 'Genealogy Tree',
        type: 'basic',
        icon: 'custom:genealogy_tree',
        link: '/genealogy-tree'
    },
    // {
    //     id: 'simUplineTagging',
    //     title: 'SIM Upline Tagging',
    //     type: 'basic',
    //     icon: 'heroicons_outline:tag',
    //     link: '/sim-upline-tagging'
    // },
    {
        id: 'reports',
        title: 'Reports',
        type: 'collapsable',
        icon: 'custom:reports',
        children: [
            {
                id: 'summary-report',
                title: 'Summary Report',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/reports/summary-report',
            },
            {
                id: 'incentive-history',
                title: 'Incentive History',
                type: 'basic',
                icon: 'mat_outline:history',
                link: '/reports/incentive-history',
            }
        ]
    },
    {
        id: 'campaign',
        title: 'Campaign',
        type: 'basic',
        icon: 'heroicons_outline:megaphone',
        link: '/campaign'
    }
];

//dealer menu
export const dealerNavigation: FuseNavigationItem[] = [
    {
        id: 'dealer-dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'custom:dashboard',
        link: '/dealer/dashboard'
    },
    {
        id: 'dealer-corporate',
        title: 'Corporate',
        type: 'collapsable',
        icon: 'heroicons_outline:building-office-2',
        children: [
            {
                id: 'corporate-register',
                title: 'Register',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/dealer/corporate/register',
            },
            {
                id: 'corporate-list',
                title: 'Submissions',
                type: 'basic',
                icon: 'heroicons_outline:document-check',
                link: '/dealer/corporates',
            },
        ]
    },
    // {
    //     id: 'topup-msisdn',
    //     title: 'Reload',
    //     type: 'basic',
    //     icon: 'heroicons_outline:device-phone-mobile',
    //     link: '/dealer/topup-msisdn',
    // },
    // {
    //     id: 'ewallet-service',
    //     title: 'E-wallet Services',
    //     type: 'basic',
    //     icon: 'heroicons_outline:wallet',
    //     link: 'dealer/ewallet'
    // },
    {
        id: 'dealer-subscriber',
        title: 'Subscribers',
        type: 'collapsable',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'register-subscriber',
                title: 'Register',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/dealer/register-subscriber',
            },
            {
                id: 'subscriber-list',
                title: 'Subscribers',
                type: 'basic',
                icon: 'heroicons_outline:users',
                link: '/dealer/subscribers',
            }
        ]
    },

];


//business menu
export const businessNavigation: FuseNavigationItem[] = [
    {
        id: 'corp-dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'custom:dashboard',
        link: '/corporate/dashboard'
    },
    {
        id: 'corp-topup-msisdn',
        title: 'Reload',
        type: 'collapsable',
        icon: 'heroicons_outline:device-phone-mobile',
        children: [
            {
                id: 'corp-topup-msisdn-buy',
                title: 'Buy Reload',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/corporate/topup-msisdn/buy',
            },
            {
                id: 'corp-topup-msisdn-transactions',
                title: 'Transactions',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/corporate/topup-msisdn/transactions',
            },
            {
                id: 'corp-topup-msisdn-failed',
                title: 'Failed Reloads',
                type: 'basic',
                icon: 'heroicons_outline:exclamation-triangle',
                link: '/corporate/topup-msisdn/failed-reloads',
            }
        ]
    },
    {
        id: 'corp-plans',
        title: 'Plans',
        type: 'collapsable',
        icon: 'mat_outline:signal_cellular_alt',
        children: [
            {
                id: 'corp-plans-buy',
                title: 'Buy Plan',
                type: 'basic',
                icon: 'heroicons_outline:shopping-bag',
                link: '/corporate/plans/buy',
            },
            {
                id: 'corp-plans-transactions',
                title: 'Transactions',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/corporate/plans/transactions',
            },
            {
                id: 'corp-plans-failed',
                title: 'Failed Plans',
                type: 'basic',
                icon: 'heroicons_outline:exclamation-triangle',
                link: '/corporate/plans/failed-plans',
            }
        ]
    },
    {
        id: 'corp-subscribers',
        title: 'Subscribers',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/corporate/subscribers',
    },
];



// Others
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }

];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
